import './vendor';
require('/src/js/vendor/magnific/jquery.magnific-popup.min.js')

function banner() {
	let banner = document.querySelector(".secret");
	banner.classList.add("is-visible")
}
      
setTimeout(banner, 60000);

$(".secret__close").click(function() {
	$(".secret").removeClass("is-visible")
});




$(".portfolio__tabsitem").not(":first").hide();
$(".portfolio__tab ").click(function() {
	$(".portfolio__tab ").removeClass("is-active").eq($(this).index()).addClass("is-active");
	$(".portfolio__tabsitem").hide().eq($(this).index()).fadeIn()
}).eq(0).addClass("is-active");



if(document.querySelector(".reviews-slider")) {
	$('.reviews-slider').slick({
		dots: false,
		infinite: false,
		speed: 1000,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		adaptiveHeight: true,
		prevArrow: '',
		nextArrow: '<button type="button" class="btn-slider next"><svg><use xlink:href="./images/sprites.svg#arrow-next"></use></svg></button>',
	});
}
if(document.querySelector(".popup-youtube")) {
	$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,

		fixedContentPos: false
	});
}
if(document.querySelector(".popup-gallery")) {
	$('.popup-gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		tLoading: 'Загрузка изображения #%curr%...',
		mainClass: 'mfp-fade mfp-img-mobile',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
			titleSrc: function(item) {
				return '';
			}
		}
	});
}

$('.popup-with-form').magnificPopup({
	type: 'inline',
	preloader: false,
	focus: '#name',
	mainClass: 'mfp-fade',
	// When elemened is focused, some mobile browsers in some cases zoom in
	// It looks not nice, so we disable it:
	callbacks: {
		beforeOpen: function() {
			if($(window).width() < 700) {
				this.st.focus = false;
			} else {
				this.st.focus = '#name';
			}
		}
	}
});


$('.form__input').blur(function(){
	if($(this).val().length !== 0) {
		  $(this).addClass('is-filled');
	}
	else {
		  $(this).removeClass('is-filled');
	}
});


$(".header__btnmenu").click(function() {
	$(this).toggleClass("is-active");
	$(".header__nav").toggleClass("is-active");
});


$(".serv-menu__btn").click(function() {
	$(this).toggleClass("is-active");
	$(".serv-menu__submenu").toggleClass("is-active");
});

$(document).mouseup( function(e){ 
	var div = $(".serv-menu"); 
	if ( !div.is(e.target)
	    && div.has(e.target).length === 0 ) { 
		$(".serv-menu__btn").removeClass("is-active");
		$(".serv-menu__submenu").removeClass("is-active");
	}
});

$(".header__nav span").click(function() {
	$(this).parents("li").find("ul").slideToggle();
});



$("#scroll-top").click(function () {
	$("body, html").animate({
		scrollTop: 0
	}, 800);
	return false;
});



if(document.querySelector("#pricecheckbox")) {
	document.querySelector("#pricecheckbox").addEventListener('change', (event) => {
		if (event.currentTarget.checked) {
			document.querySelector("#price").textContent = '140,000'
		} else {
			document.querySelector("#price").textContent = '180,000'
		}
	})
}
